module.exports = __webpack_public_path__ + "static/media/testout.7489338d.svg";